import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/accounting/monetary-movements/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

/**
 * There is deliberately no update and no delete here. The API refuses both —
 * a movement is corrected with an adjustment, not rewritten — and a service
 * method that always 405s would only invite someone to wire a button to it.
 */
const monetaryMovementService = {
  listMovements: (params = {}) => axios.get(BASE_URL, { headers: getHeaders(), params }),

  createMovement: (data) => axios.post(BASE_URL, data, { headers: getHeaders() }),

  toggleActive: (id) =>
    axios.patch(`${BASE_URL}${id}/toggle_active/`, {}, { headers: getHeaders() })
};

export default monetaryMovementService;
